import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'

type IChangePhoneModalActionsProps = {
  store: ProfileStore
}

export const ChangePhoneModalActions = observer(({ store }: IChangePhoneModalActionsProps) => {
  const {
    loading,
    phoneNewInputStore,
    handleChangePhoneSave,
    currentPasswordConfirmed,
    onCloseModal,
    isFieldChanged,
  } = store

  const isSaveDisabled =
    loading ||
    !currentPasswordConfirmed ||
    !phoneNewInputStore.isValidNumber ||
    !isFieldChanged('number', phoneNewInputStore.fullUnformattedNumber)

  return (
    <>
      <Button
        text='Cancel'
        onClick={onCloseModal}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text='Save'
        onClick={handleChangePhoneSave}
        disabled={isSaveDisabled}
        loading={loading}
      />
    </>
  )
})
